import { call, select, takeLatest } from "redux-saga/effects";
import * as actions from "../actions/itemActions";
import { editOrderingMenuItem } from "../../axios/editOrderingMenuItem";
import { selectToken } from "../../../../redux-store/selectors";
import { editOrderingItemAction } from "../../constants/actions";
import { union } from "ts-action";
import { handleOptimism } from "./handleOptimism";
import { customNotify } from "../../SharedComponent/Notification";
import { translateMenuError } from "./changeItemCategorySaga";
import menuErrorMessages from "../../i18n/strings/menuErrorMessages";
import i18n from "../../../../i18n/i18n";
const actionType = union({ a: actions.editOrderingItem } as any);

function* editMenuItemSaga(action: any) {
  try {
    const { id } = action.payload;
    const token = yield select(selectToken);
    const item = yield call(editOrderingMenuItem, token, action.payload, id);
    if (item.status) {
      return { ...action.payload };
    }
  } catch (e: any) {
    const status = e?.response?.status;
    const apiMessage = e?.response?.data?.message;
    const errorMessage =
      status !== 500 && apiMessage
        ? getLocalizedApiMessage(apiMessage)
        : translateMenuError(menuErrorMessages.editItem);
    customNotify.error(errorMessage);
    throw e;
  }
}

export function* watchEditMenuItemSaga() {
  yield takeLatest(
    editOrderingItemAction.requested,
    handleOptimism(editMenuItemSaga, {
      success: actions.editOrderingItemSuccess as any,
      failure: actions.editOrderingItemFailure as any,
    }, { maxTries: 0 })
  );
}

const getLocalizedApiMessage = (message: string): string => {
  try {
    const parsed = JSON.parse(message);
    if (parsed && typeof parsed === "object") {
      const lang = i18n.language?.split("-")[0] || "en";
      return parsed[lang] || parsed.en || message;
    }
  } catch {
    // message is not a JSON object, use as-is
  }
  return message;
};

